<template>
	<!-- Slider main container -->
	<div id="table4">
		<el-table :data="data" style="width: 100%;height: 100%;" @row-click="rowClick">
			<el-table-column prop="tmApplicant" label="企业名称" width="550">
			</el-table-column>
			<el-table-column prop="applyCnt" label="申请过的商标数量">
			</el-table-column>
			<el-table-column prop="validCnt" :label="year ? '今年下证商标数量' : '有效商标数量'">
			</el-table-column>
			<el-table-column label="通过率" class-name='column3'>
				<template slot-scope="scope">					
					<span v-if="scope.row.applyCnt != 0">{{ ((scope.row.validCnt / scope.row.applyCnt) * 100).toFixed(2) }}%</span>
					<span v-else>0.00%</span>
				</template>
			</el-table-column>
			<el-table-column prop="agentCnt" label="代理公司数量">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		name: "swiper-list",
		data() {
			return {

			};
		},
		props: {
			page: {
				type: Number,
				default: () => 0,
			},
			data: {
				type: Array,
				default: () => [],
			},
			// 根据选择器来变换标题
			year: {
				type: String,
				default: () => "",
			},
		},
		mounted() {

		},
		methods: {
			rowClick(row, column, event) {				
				this.$emit('goLevel4', row)
			}
		},
	};
</script>

<style scoped lang="less">
	#table4 {
		width: 100%;
		height: 100%;
		padding-top: 50px;
		.el-table, .el-table__expanded-cell {
			background: none;
		}
		.el-table::before {
			left: 0;
			top: 0px;
			width: 100%;
			height: 1px;
			background-color: #69B1FF;
		}
	}
</style>
<style lang="less">
	#table4 .el-table thead tr {		
		height: 78px;
		line-height: 78px;
		background-color: #1e427e;
	}
	#table4 .el-table tbody tr {		
		height: 78px;
		line-height: 78px;
		background: none;
		&:hover > td {
			background-color: #1e427e;
		}
	}
	
	#table4 .el-table th.el-table__cell {
		background: none;
		padding: 0;
	}
	#table4 .el-table .cell {
		font-size: 24px;
		color: #FFFFFF;
	}
	#table4 .el-table th .cell {
		line-height: 24px;
	}
	#table4 .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #69B1FF;
	}
	#table4 .el-table td.column3 .cell {
		color: #18FFB0 !important;
	}
</style>